import { type ComponentProps, useCallback } from 'react';
import Animated from 'react-native-reanimated';

import type { ScrollspyScrollViewRef } from '../../useScrollspy';

// ─────────────────────────────────────────────────────────────────────────────

export const ScrollspyScrollView = (props: ScrollspyScrollViewProps) => {
  const { ref, children, onContentSizeChange, ...scrollViewProps } = props;

  // ─── Handlers ──────────────────────────────────────────────────────────

  const handleContentSizeChange = useCallback(
    (width: number, height: number) => {
      if (typeof onContentSizeChange === 'function') {
        onContentSizeChange(width, height);
      }
    },
    [onContentSizeChange],
  );

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Animated.ScrollView
      ref={ref}
      scrollEventThrottle={16}
      onContentSizeChange={handleContentSizeChange}
      {...scrollViewProps}
    >
      {children}
    </Animated.ScrollView>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ScrollspyScrollViewProps = Omit<
  ComponentProps<typeof Animated.ScrollView>,
  'ref' | 'horizontal'
> & {
  ref?: ScrollspyScrollViewRef;
};
